// Media names conventionally start with "The" ("The Atlantic", "The New York
// Times"), which would otherwise clump a third of any source list under T.
// Sorting drops a leading "The " so these fall under their real letter, the
// way a library catalog would. Shared so every source list in the app agrees
// on where a source falls, rather than each screen inventing its own rule.
const LEADING_THE = /^the\s+/i;

export function sourceSortName(name) {
  return (name || '').replace(LEADING_THE, '');
}

export function compareSourceNames(a, b) {
  return sourceSortName(a).localeCompare(sourceSortName(b));
}
